/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FlashcardStatus } from '../models/FlashcardStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FlashcardStatusesService {
    /**
     * Get all flashcard statuses
     * @returns FlashcardStatus successful
     * @throws ApiError
     */
    public static getAllFlashcardStatuses(): CancelablePromise<Array<FlashcardStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/flashcard_statuses.json',
        });
    }
    /**
     * Create or update flashcard status
     * @param requestBody
     * @returns FlashcardStatus successful
     * @throws ApiError
     */
    public static markFlashcard(
        requestBody?: {
            flashcard_id: string;
            custom_deck_id?: string | null;
            last_response: 'unanswered' | 'incorrect' | 'unsure' | 'correct';
            bucket_id: 'unseen' | '0' | '1' | '2' | '3';
        },
    ): CancelablePromise<FlashcardStatus> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/flashcard_statuses.json',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Clear user flashcard statuses
     * @param requestBody
     * @returns any successful
     * @throws ApiError
     */
    public static clearFlashcardStatuses(
        requestBody?: {
            flashcard_ids?: Array<string>;
        },
    ): CancelablePromise<{
        destroy: Array<string>;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/flashcard_statuses/destroy_all.json',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
